import { XCircleIcon } from '@heroicons/react/24/outline';
import { useSearchParams } from 'react-router';
import { appPath } from '../constants/appBasePath';
import DashboardLayout from '../components/DashboardLayout';

const messages: Record<string, { title: string; body: string }> = {
  server: {
    title: 'Something went wrong',
    body: 'The dashboard service encountered an error. Please try again.',
  },
  connection: {
    title: 'Cannot connect to server',
    body: 'Could not reach the services that power your dashboard. Please check your connection and try again.',
  },
};

export default function ErrorPage() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') ?? 'server';
  const { title, body } = messages[type] ?? messages.server;

  return (
    <DashboardLayout>
      <div className="flex min-h-[calc(100vh-73px)] items-center justify-center px-6 py-16">
        <div className="w-full max-w-md rounded-[10px] border border-theme-border bg-surface px-10 py-8 text-center">
          <XCircleIcon className="mx-auto mb-4 h-10 w-10 text-gold-500" />
          <h1 className="mb-2 text-2xl font-semibold text-on-surface">
            {title}
          </h1>
          <p className="mb-8 text-base text-on-surface-tertiary">{body}</p>
          <a
            href={appPath('/')}
            className="inline-block rounded-none bg-gold-500 px-8 py-3 text-base font-semibold text-ink transition-colors hover:bg-gold-600"
          >
            Back to start
          </a>
        </div>
      </div>
    </DashboardLayout>
  );
}
